import configService from '@/services/configService';

export default {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    error: null,
  },
  mutations: {
    UPLOAD_CONFIG_REQUEST(state) {
      state.loading = true;
      state.error = null;
    },
    UPLOAD_CONFIG_SUCCESS(state, config) {
      state.loading = false;
      state.data = config;
    },
    UPLOAD_CONFIG_FAILURE(state, error) {
      state.loading = false;
      state.error = error;
    },
    FETCH_CONFIG_REQUEST(state) {
      state.loading = true;
      state.error = null;
    },
    FETCH_CONFIG_SUCCESS(state, config) {
      state.loading = false;
      state.data = config;
      state.error = null;
    },
    FETCH_CONFIG_FAILURE(state, error) {
      state.loading = false;
      state.error = error;
    },
    UPDATE_CONFIG_REQUEST(state) {
      state.loading = true;
      state.error = null;
    },
    UPDATE_CONFIG_SUCCESS(state, config) {
      state.loading = false;
      state.data = config;
      state.error = null;
    },
    UPDATE_CONFIG_FAILURE(state, error) {
      state.loading = false;
      state.error = error;
    },
    CLEAR_CONFIG(state) {
      state.data = null;
      state.error = null;
    },
  },
  actions: {
    async uploadConfig({ commit }, config) {
      commit('UPLOAD_CONFIG_REQUEST');
      try {
        await configService.uploadConfig(config);
        commit('UPLOAD_CONFIG_SUCCESS', config);
      } catch (err) {
        commit(
          'UPLOAD_CONFIG_FAILURE',
          err.response?.data?.message || err.message || 'Upload failed',
        );
      }
    },
    async fetchConfig({ commit }) {
      commit('FETCH_CONFIG_REQUEST');
      try {
        const response = await configService.getConfig();
        const config = response.data?.data || response.data;
        commit('FETCH_CONFIG_SUCCESS', config);
        return config;
      } catch (err) {
        const error = err.response?.data?.message || err.message || 'Failed to fetch config';
        commit('FETCH_CONFIG_FAILURE', error);
        throw err;
      }
    },
    async updateConfig({ commit }, configData) {
      commit('UPDATE_CONFIG_REQUEST');
      try {
        await configService.updateConfig(configData);
        commit('UPDATE_CONFIG_SUCCESS', configData);
      } catch (err) {
        const error = err.response?.data?.message || err.message || 'Failed to update config';
        commit('UPDATE_CONFIG_FAILURE', error);
        throw err;
      }
    },
  },
};
